var _jsxFileName = "/media/data/Sandbox/soapbox-defake/app/soapbox/components/sidebar-navigation.tsx";
import React from 'react';
import { defineMessages, FormattedMessage, useIntl } from 'react-intl';
import { getSettings } from 'soapbox/actions/settings';
import DropdownMenu from 'soapbox/containers/dropdown-menu-container';
import ComposeButton from 'soapbox/features/ui/components/compose-button';
import { useAppSelector, useOwnAccount } from 'soapbox/hooks';
import { getFeatures } from 'soapbox/utils/features';
import SidebarNavigationLink from './sidebar-navigation-link';
const messages = defineMessages({
  follow_requests: {
    "id": "navigation_bar.follow_requests",
    "defaultMessage": "Follow requests"
  },
  bookmarks: {
    "id": "column.bookmarks",
    "defaultMessage": "Bookmarks"
  },
  lists: {
    "id": "column.lists",
    "defaultMessage": "Lists"
  },
  developers: {
    "id": "navigation.developers",
    "defaultMessage": "Developers"
  },
  dashboard: {
    "id": "tabs_bar.dashboard",
    "defaultMessage": "Dashboard"
  },
  all: {
    "id": "tabs_bar.all",
    "defaultMessage": "All"
  },
  fediverse: {
    "id": "tabs_bar.fediverse",
    "defaultMessage": "Fediverse"
  }
});
/** Desktop sidebar with links to different views in the app. */

const SidebarNavigation = () => {
  const intl = useIntl();
  const instance = useAppSelector(state => state.instance);
  const settings = useAppSelector(state => getSettings(state));
  const account = useOwnAccount();
  const notificationCount = useAppSelector(state => state.notifications.unread);
  const chatsCount = useAppSelector(state => state.chats.items.reduce((acc, curr) => acc + Math.min(curr.unread || 0, 1), 0));
  const followRequestsCount = useAppSelector(state => state.user_lists.follow_requests.items.count());
  const dashboardCount = useAppSelector(state => state.admin.openReports.count() + state.admin.awaitingApproval.count());
  const features = getFeatures(instance);

  const makeMenu = () => {
    const menu = [];

    if (account) {
      if (account.locked || followRequestsCount > 0) {
        menu.push({
          to: '/follow_requests',
          text: intl.formatMessage(messages.follow_requests),
          icon: require('@tabler/icons/user-plus.svg'),
          count: followRequestsCount
        });
      }

      if (features.bookmarks) {
        menu.push({
          to: '/bookmarks',
          text: intl.formatMessage(messages.bookmarks),
          icon: require('@tabler/icons/bookmark.svg')
        });
      }

      if (features.lists) {
        menu.push({
          to: '/lists',
          text: intl.formatMessage(messages.lists),
          icon: require('@tabler/icons/list.svg')
        });
      }

      if (settings.get('isDeveloper')) {
        menu.push({
          to: '/developers',
          icon: require('@tabler/icons/code.svg'),
          text: intl.formatMessage(messages.developers)
        });
      }

      if (account.staff) {
        menu.push({
          to: '/soapbox/admin',
          icon: require('@tabler/icons/dashboard.svg'),
          text: intl.formatMessage(messages.dashboard),
          count: dashboardCount
        });
      }

      if (features.publicTimeline) {
        menu.push(null);
      }
    }

    if (features.publicTimeline) {
      menu.push({
        to: '/timeline/local',
        icon: features.federating ? require('@tabler/icons/users.svg') : require('@tabler/icons/world.svg'),
        text: features.federating ? instance.title : intl.formatMessage(messages.all)
      });
    }

    if (features.publicTimeline && features.federating) {
      menu.push({
        to: '/timeline/fediverse',
        icon: require('assets/icons/fediverse.svg'),
        text: intl.formatMessage(messages.fediverse)
      });
    }

    return menu;
  };

  const menu = makeMenu();
  /** Conditionally render the supported messages link */

  const renderMessagesLink = () => {
    if (features.chats) {
      return /*#__PURE__*/React.createElement(SidebarNavigationLink, {
        to: "/chats",
        icon: require('@tabler/icons/messages.svg'),
        count: chatsCount,
        text: /*#__PURE__*/React.createElement(FormattedMessage, {
          id: "tabs_bar.chats",
          defaultMessage: "Chats",
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 118,
            columnNumber: 17
          }
        }),
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 114,
          columnNumber: 9
        }
      });
    }

    if (features.directTimeline || features.conversations) {
      return /*#__PURE__*/React.createElement(SidebarNavigationLink, {
        to: "/messages",
        icon: require('@tabler/icons/mail.svg'),
        text: /*#__PURE__*/React.createElement(FormattedMessage, {
          id: "navigation.direct_messages",
          defaultMessage: "Messages",
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 128,
            columnNumber: 17
          }
        }),
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 125,
          columnNumber: 9
        }
      });
    }

    return null;
  };

  return /*#__PURE__*/React.createElement("div", {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 137,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col space-y-2",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 138,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(SidebarNavigationLink, {
    to: "/",
    icon: require('@tabler/icons/home.svg'),
    text: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "tabs_bar.home",
      defaultMessage: "Home",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 142,
        columnNumber: 17
      }
    }),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 139,
      columnNumber: 9
    }
  }), /*#__PURE__*/React.createElement(SidebarNavigationLink, {
    to: "/search",
    icon: require('@tabler/icons/search.svg'),
    text: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "tabs_bar.search",
      defaultMessage: "Search",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 148,
        columnNumber: 17
      }
    }),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 145,
      columnNumber: 9
    }
  }), account && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SidebarNavigationLink, {
    to: "/notifications",
    icon: require('@tabler/icons/bell.svg'),
    count: notificationCount,
    text: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "tabs_bar.notifications",
      defaultMessage: "Notifications",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 157,
        columnNumber: 21
      }
    }),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 153,
      columnNumber: 13
    }
  }), renderMessagesLink(), /*#__PURE__*/React.createElement(SidebarNavigationLink, {
    to: "/@".concat(account.acct),
    icon: require('@tabler/icons/user.svg'),
    text: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "tabs_bar.profile",
      defaultMessage: "Profile",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 165,
        columnNumber: 21
      }
    }),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 162,
      columnNumber: 13
    }
  }), /*#__PURE__*/React.createElement(SidebarNavigationLink, {
    to: "/settings",
    icon: require('@tabler/icons/settings.svg'),
    text: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "tabs_bar.settings",
      defaultMessage: "Settings",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 171,
        columnNumber: 21
      }
    }),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 168,
      columnNumber: 13
    }
  })), menu.length > 0 && /*#__PURE__*/React.createElement(DropdownMenu, {
    items: menu,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 177,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement(SidebarNavigationLink, {
    icon: require('@tabler/icons/dots-circle-horizontal.svg'),
    count: dashboardCount,
    text: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "tabs_bar.more",
      defaultMessage: "More",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 181,
        columnNumber: 21
      }
    }),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 178,
      columnNumber: 13
    }
  }))), account && /*#__PURE__*/React.createElement(ComposeButton, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 188,
      columnNumber: 9
    }
  }));
};

export default SidebarNavigation;